var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSportwagen = function SvgSportwagen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 77 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Sportwagen_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.654 9c-1.043-.006-2.09.347-3.045.983L15.606 20.638a2.5 2.5 0 0 1-1.385.42H8.01c-1.33 0-2.605.527-3.544 1.465A4.995 4.995 0 0 0 3 26.056v5h7.65a7.503 7.503 0 0 1 14.7 0h26.3a7.503 7.503 0 0 1 14.7 0h5.15v-.008h.751l1.444-9.992H32v-3h20.302v-6.436c-7.694-2-13.898-2.599-17.648-2.62Zm20.648 3.451v5.606h14.8a105.552 105.552 0 0 0-14.8-5.606ZM66.35 34.057h5.15v.002h1.25v-.003a2.502 2.502 0 0 0 2.42-2.225l1.612-11.16a3.483 3.483 0 0 0-1.861-3.602C57.273 8.084 41.916 6.043 34.672 6c-1.741-.01-3.363.58-4.726 1.486L14.07 18.057H8.011A8.016 8.016 0 0 0 2.347 20.4 7.995 7.995 0 0 0 0 26.056v5.5a2.5 2.5 0 0 0 2.5 2.5h8.15a7.503 7.503 0 0 0 14.7 0h26.3a7.503 7.503 0 0 0 14.7 0Zm-52.85-1.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Zm41 0a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Sportwagen_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h77v40H0z"
  })))));
};
export default SvgSportwagen;